import { Component, DoCheck, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { ItemBaseModel } from '@libs/form/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export abstract class ItemBaseComponent<T extends ItemBaseModel = ItemBaseModel> implements DoCheck {
  @HostBinding('attr.hidden')
  public hidden: string | null = null;

  public abstract data: T;

  @HostBinding('class')
  public get classList(): string[] {
    return ['form-item'];
  }

  public ngDoCheck(): void {
    this.hidden = this.data.attributes?.hidden ? '' : null;
  }
}
